// extracted by mini-css-extract-plugin
export default {"greeting":"home_greeting__b4sLX","serviceInfo":"home_serviceInfo__pguSo","founders":"home_founders__R2adj","advice":"home_advice__Tm22X"};